import { InjectionToken } from '@angular/core';

export const WINDOW: InjectionToken<Window> = new InjectionToken<Window>('Global window object', {
  providedIn: 'root',
  factory: () => window,
});
